import React from 'react';
import data from '../../../utils/data';
import {FieldGroup, FieldControl, FieldArray, FormBuilder} from 'react-reactive-form';
import LinkLookupControl from './LinkLookupControl';

const renderers = {
        textBox: ({handler, touched, hasError, errors, meta: { label, sublabel, placeholder, width, padding, expandable=true, onChange=null}}) => {
            const change = (e) => {
                e.preventDefault();
                if (onChange) {
                    onChange(e.target.value);
                }
                handler().onChange(e);
            }
            return (
                <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null, 
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}>
                    {expandable ?
                        <details open>
                            {label &&
                                <summary className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                            }
                            {sublabel &&
                                <summary className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                            }
                            <input placeholder={placeholder} 
                                className="form-field" 
                                style={{width: width ? width : '100%', fontSize: '14px'}} 
                                {...handler()}
                                onChange={change}
                            />
                        </details>
                    :
                        <div>
                            {label &&
                                <div className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                            }
                            {sublabel &&
                                <div className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                            }
                            <input placeholder={placeholder} 
                                className="form-field" 
                                style={{width: width ? width : '100%', fontSize: '14px'}}
                                {...handler()}
                                onChange={change}
                            />
                        </div>
                    }
                    <div>
                        <span style={{color: 'indianred', fontSize: '14px'}}>
                            {hasError('required') && `${label ? label : ''} is required`}
                            {hasError('pattern') && `${label ? label : ''} format is invalid`}
                            {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                            {hasError('invalidCountryCode') && 'Invalid country code'}
                        </span>
                    </div>
                </div>
            )
        },

        textArea: ({handler, touched, hasError, errors, meta: { label, sublabel, placeholder, width, height, padding, monospace=false, expandable=true, expanded=true}}) => (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null, 
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                    <details open={expanded}>
                        {label &&
                            <summary className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        <textarea className="form-field" {...handler()} 
                            placeholder={placeholder} 
                            style={{
                                width: width ? width : '100%', 
                                fontSize: '14px',
                                height: height ? height : '200px',
                                fontFamily: monospace ? 'monospace' : 'Titillium'
                            }}
                        />
                    </details>                
                :
                    <div>
                        {label &&
                            <div className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        <textarea className="form-field" {...handler()} 
                            placeholder={placeholder} 
                            style={{
                                width: width ? width : '100%', 
                                fontSize: '14px',
                                height: height ? height : '200px',
                                fontFamily: monospace ? 'monospace' : 'Titillium'
                            }}
                        />
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('pattern') && `${label ? label : ''} format is invalid`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                        {hasError('invalidCountryCode') && 'Invalid country code'}
                    </span>
                </div>
            </div>
        ),

        rangeSlider: ({handler, touched, hasError, errors, meta: { label, padding, expandable=true}}) => (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null,
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                    <details open>
                        <summary className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        <input className="form-field" {...handler()} type="range" min="0.000" max="1.000" step=".001" style={{width: '100%', fontSize: '14px'}}/>
                        <output style={{fontSize: '14px'}}>{handler().value}</output>
                    </details>               
                :
                    <div>
                        <div className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        <input className="form-field" {...handler()} type="range" min="0.000" max="1.000" step=".001" style={{width: '100%', fontSize: '14px'}}/>
                        <output style={{fontSize: '14px'}}>{handler().value}</output>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('pattern') && `${label ? label : ''} format is invalid`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        selectBox: ({handler, touched, hasError, errors, meta: { label, sublabel, padding, items, expandable=true}}) => (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null, 
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                    <details open>
                        {label &&
                            <summary className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        <select className='form-field' style={{width: '100%', fontSize: '14px'}} {...handler()}>
                            {items.map((item) => {
                                return <option key={item} value={item}>{item}</option>
                            })}
                        </select>
                    </details>                
                :
                    <div>
                        {label &&
                            <div className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        <select className='form-field' style={{width: '100%', fontSize: '14px'}} {...handler()}>
                            {items.map((item) => {
                                return <option key={item} value={item}>{item}</option>
                            })}
                        </select>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                        {hasError('invalidCountryCode') && 'Invalid country code'}
                    </span>
                </div>
            </div>
        ),

        comboBox: ({handler, touched, hasError, errors, meta: { label, sublabel, padding, placeholder, items, expandable=true, onSelectChange=null, onTextChange=null}}) => {
            const textChange = (e) => {
                e.preventDefault();
                if (onTextChange) {
                    onTextChange(e.target.value);
                }
                handler().onChange(e);
            }
            const selectChange = (e) => {
                e.preventDefault();
                if (onSelectChange) {
                    onSelectChange(e.target.value);
                }
                handler().onChange(e);
            }
            return (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null, 
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                    <details open>
                        {label &&
                            <summary className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        <div className="form-field-combobox">
                            <select className='form-field' {...handler()}
                             onChange={selectChange}
                             >
                                {items.map((item) => {
                                    return <option key={item} value={item}>{item}</option>
                                })}
                            </select>
                            <input type="text" {...handler()} onChange={textChange} placeholder={placeholder ? placeholder : ''} style={{fontSize: '14px'}}/>
                        </div>
                    </details>                
                :
                    <div>
                        {label &&
                            <div className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        <div className="form-field-combobox">
                            <select className='form-field' {...handler()} onChange={selectChange}>
                                {items.map((item) => {
                                    return <option key={item} value={item}>{item}</option>
                                })}
                            </select>
                            <input type="text" {...handler()} onChange={textChange} placeholder={placeholder ? placeholder : ''} style={{fontSize: '14px'}}/>
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                        {hasError('invalidCountryCode') && 'Invalid country code'}
                    </span>
                </div>
            </div>
        )},

        numberBox: ({handler, touched, hasError, errors, meta: { label, expandable=true}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                     <details open>
                        <summary className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        <input type="number" className="form-field" style={{width: '100%', fontSize: '14px'}} {...handler()} />
                    </details>               
                :
                    <div>
                        <div className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        <input type="number" className="form-field" style={{width: '100%', fontSize: '14px'}} {...handler()} />
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        checkBox: ({handler, touched, hasError, errors, meta: { label, sublabel, placeholder, width, padding, expandable=true}}) => (
            <div className="form-field-wrapper" style={{
                    background: label ? 'whitesmoke' : null, 
                    padding: padding ? padding : '10px', 
                    borderRadius: '5px'
                }}>
                {expandable ?
                    <details open>
                        {label &&
                            <summary className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        <input type="checkbox" 
                            placeholder={placeholder} 
                            className="form-field" 
                            style={{width: '20px', height: '20px'}} 
                            checked={handler().value} {...handler()} />
                    </details>
                :
                    <div>
                        {label &&
                            <div className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        <input type="checkbox" 
                            placeholder={placeholder} 
                            className="form-field" 
                            style={{width: '13px', height: '13px'}} 
                            checked={handler().value} {...handler()} />
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('pattern') && `${label ? label : ''} format is invalid`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        textBoxArray: ({controls, touched, hasError, errors, meta: {label, sublabel, addLabel, padding, onAdd, onRemove, image, expandable=true, expanded=true}}) => (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null, 
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                     <details open={expanded}>
                        {label &&
                            <summary  className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary  className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        {controls.map((control, index) => (
                            <table key={`${index}_${controls.length}`} style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                            <FieldControl control={control} render={renderers.textBox} meta={{padding: '0px', expandable: false}}/>
                                            {image && !window._externalUrlsDisable &&
                                                <img src={control.value} style={{maxHeight: '150px', maxWidth: '150px', marginTop: '10px', borderRadius: '5px'}}/>
                                            }
                                        </td>
                                        <td style={{paddingLeft: '5px', verticalAlign: 'top'}}>
                                            <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete item">
                                                <span className="fa fa-trash"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>               
                :
                    <div>
                        {label &&
                            <div  className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div  className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        {controls.map((control, index) => (
                            <table key={`${index}_${controls.length}`} style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                            <FieldControl control={control} render={renderers.textBox} meta={{padding: '0px', expandable: false}}/>
                                            {image && !window._externalUrlsDisable &&
                                                <img src={control.value} style={{maxHeight: '150px', maxWidth: '150px', marginTop: '10px', borderRadius: '5px'}}/>
                                            }
                                        </td>
                                        <td style={{paddingLeft: '5px', verticalAlign: 'top'}}>
                                            <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete item">
                                                <span className="fa fa-trash"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        selectBoxArray: ({controls, touched, hasError, errors, meta: {label, sublabel, addLabel, padding, onAdd, onRemove, items, expandable=true, expanded=true}}) => (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null,
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                    <details open={expanded}>
                        {label &&
                            <summary  className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary  className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        {controls.map((control, index) => (
                            <table key={`${index}_${controls.length}`} style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                            <FieldControl control={control} render={renderers.selectBox} meta={{padding: '0px', items, expandable: false}}/>
                                        </td>
                                        <td style={{paddingLeft: '5px', verticalAlign: 'top'}}>
                                            <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete item">
                                                <span className="fa fa-trash"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title="Create new item">
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        {label &&
                            <div  className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div  className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        {controls.map((control, index) => (
                            <table key={`${index}_${controls.length}`} style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                            <FieldControl control={control} render={renderers.selectBox} meta={{padding: '0px', items, expandable: false}}/>
                                        </td>
                                        <td style={{paddingLeft: '5px', verticalAlign: 'top'}}>
                                            <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete item">
                                                <span className="fa fa-trash"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title="Create new item">
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        comboBoxArray: ({controls, touched, hasError, errors, meta: {label, sublabel, addLabel, padding, onAdd, onRemove, items, expandable=true, expanded=true}}) => (
            <div className="form-field-wrapper" style={{
                        background: label ? 'whitesmoke' : null,
                        padding: padding ? padding : '10px', 
                        borderRadius: '5px'
                    }}
                >
                {expandable ?
                    <details open={expanded}>
                        {label &&
                            <summary  className="form-label" style={{paddingBottom: '5px'}}>{label}</summary>
                        }
                        {sublabel &&
                            <summary  className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</summary>
                        }
                        {controls.map((control, index) => (
                            <table key={`${index}_${controls.length}`} style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                            <FieldControl control={control} render={renderers.comboBox} meta={{padding: '0px', items, expandable: false}}/>
                                        </td>
                                        <td style={{paddingLeft: '5px', verticalAlign: 'top'}}>
                                            <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete item">
                                                <span className="fa fa-trash"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title="Create new item">
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        {label &&
                            <div  className="form-label" style={{paddingBottom: '5px'}}>{label}</div>
                        }
                        {sublabel &&
                            <div  className="form-label" style={{paddingBottom: '3px', fontSize: '12px', fontWeight: 'bold'}}>{sublabel}</div>
                        }
                        {controls.map((control, index) => (
                            <table key={`${index}_${controls.length}`} style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                            <FieldControl control={control} render={renderers.comboBox} meta={{padding: '0px', items, expandable: false}}/>
                                        </td>
                                        <td style={{paddingLeft: '5px', verticalAlign: 'top'}}>
                                            <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete item">
                                                <span className="fa fa-trash"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title="Create new item">
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        location: ({handler, touched, hasError, errors, meta: { label, placeholder, width, padding, locationField='location', expandable=true, hidden=null}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: padding ? padding : '10px', borderRadius: '5px'}}>
                {expandable ?
                    <details open>
                        <summary className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {(!hidden || hidden.indexOf('name') == -1) &&
                            <FieldControl name={`${locationField}.name`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Name', 
                                    padding: '0px', 
                                    placeholder: 'Enter location name',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('streetAddress') == -1) &&
                            <FieldControl name={`${locationField}.streetAddress`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Street Address', 
                                    padding: '0px', 
                                    placeholder: 'Enter street address',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('cityLabel') == -1) &&
                            <FieldControl name={`${locationField}.cityLabel`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'City',
                                    padding: '0px', 
                                    placeholder: 'Enter city',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('postalCode') == -1) &&
                            <FieldControl name={`${locationField}.postalCode`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Postal Code',
                                    padding: '0px', 
                                    placeholder: 'Enter postal code',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('countryLabel') == -1) &&
                            <FieldControl name={`${locationField}.countryLabel`} render={renderers.comboBox} 
                                meta={{
                                    sublabel: 'Country',
                                    padding: '0px', 
                                    placeholder: 'Enter country',
                                    items: data.getCountries(),
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('countryCode') == -1) &&
                            <FieldControl name={`${locationField}.countryCode`} render={renderers.comboBox} 
                                meta={{
                                    sublabel: 'Country Code',
                                    padding: '0px', 
                                    placeholder: 'Enter country code',
                                    items: data.getCountryCodes(),
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('admin1Label') == -1) &&
                            <FieldControl name={`${locationField}.admin1Label`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Admin1 Label',
                                    padding: '0px', 
                                    placeholder: 'Enter admin1',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('latitude') == -1) &&
                            <FieldControl name={`${locationField}.latitude`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Latitude',
                                    padding: '0px', 
                                    placeholder: 'Enter latitude',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('longitude') == -1) &&
                            <FieldControl name={`${locationField}.longitude`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Longitude',
                                    padding: '0px', 
                                    placeholder: 'Enter longitude',
                                    expandable: false
                                }}
                            />
                        }
                    </details>                
                :
                    <div>
                        <div className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {(!hidden || hidden.indexOf('name') == -1) &&
                            <FieldControl name={`${locationField}.name`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Name', 
                                    padding: '0px', 
                                    placeholder: 'Enter location name',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('streetAddress') == -1) &&
                            <FieldControl name={`${locationField}.streetAddress`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Street Address', 
                                    padding: '0px', 
                                    placeholder: 'Enter street address',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('cityLabel') == -1) &&
                            <FieldControl name={`${locationField}.cityLabel`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'City',
                                    padding: '0px', 
                                    placeholder: 'Enter city',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('postalCode') == -1) &&
                            <FieldControl name={`${locationField}.postalCode`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Postal Code',
                                    padding: '0px', 
                                    placeholder: 'Enter postal code',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('countryLabel') == -1) &&
                            <FieldControl name={`${locationField}.countryLabel`} render={renderers.comboBox} 
                                meta={{
                                    sublabel: 'Country',
                                    padding: '0px', 
                                    placeholder: 'Enter country',
                                    items: data.getCountries(),
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('countryCode') == -1) &&
                            <FieldControl name={`${locationField}.countryCode`} render={renderers.comboBox} 
                                meta={{
                                    sublabel: 'Country Code',
                                    padding: '0px', 
                                    placeholder: 'Enter country code',
                                    items: data.getCountryCodes(),
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('admin1Label') == -1) &&
                            <FieldControl name={`${locationField}.admin1Label`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Admin1 Label',
                                    padding: '0px', 
                                    placeholder: 'Enter admin1',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('latitude') == -1) &&
                            <FieldControl name={`${locationField}.latitude`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Latitude',
                                    padding: '0px', 
                                    placeholder: 'Enter latitude',
                                    expandable: false
                                }}
                            />
                        }
                        {(!hidden || hidden.indexOf('longitude') == -1) &&
                            <FieldControl name={`${locationField}.longitude`} render={renderers.textBox} 
                                meta={{
                                    sublabel: 'Longitude',
                                    padding: '0px', 
                                    placeholder: 'Enter longitude',
                                    expandable: false
                                }}
                            />
                        }
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        stocksArray: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, expandable=true, hidden=null}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                     <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                        }}>
                                        <tbody>
                                            {(!hidden || hidden.indexOf('exchange') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="exchange" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Exchange',
                                                                padding: '0px', 
                                                                placeholder: 'Enter exchange',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('tickerSymbol') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="tickerSymbol" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Ticker',
                                                                padding: '0px', 
                                                                placeholder: 'Enter ticker symbol',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('mic') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="mic" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'MIC',
                                                                padding: '0px', 
                                                                placeholder: 'Enter MIC code',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('primary') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="primary" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Primary',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('current') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete stock">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>               
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                        }}>
                                        <tbody>
                                            {(!hidden || hidden.indexOf('exchange') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="exchange" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Exchange',
                                                                padding: '0px', 
                                                                placeholder: 'Enter exchange',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('tickerSymbol') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="tickerSymbol" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Ticker',
                                                                padding: '0px', 
                                                                placeholder: 'Enter ticker symbol',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('mic') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="mic" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'MIC',
                                                                padding: '0px', 
                                                                placeholder: 'Enter MIC code',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('primary') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="primary" 
                                                            render={renderers.checkbox} 
                                                            meta={{
                                                                sublabel: 'Primary',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('current') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkbox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td style={{paddingTop: '12px', paddingLeft: '5px'}}>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete stock">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        phoneNumbersArray: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, onChange, expandable=true, hidden=null}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                     <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                        }}>
                                        <tbody>
                                            {(!hidden || hidden.indexOf('value') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="value" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Number',
                                                                padding: '0px', 
                                                                placeholder: 'Enter phone number',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('type') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="type" render={renderers.selectBox} 
                                                            meta={{
                                                                sublabel: 'Type',
                                                                padding: '0px', 
                                                                placeholder: 'Enter phone type',
                                                                items: data.getPhoneTypes(),
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('current') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('startDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="startDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Start Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter start date',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('endDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="endDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'End Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter end date',
                                                                expandable: false,
                                                                onChange: (val) => {onChange(val, 'endDate', index)}
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete phone">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>               
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                        }}>
                                        <tbody>
                                            {(!hidden || hidden.indexOf('value') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="value" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Number',
                                                                padding: '0px', 
                                                                placeholder: 'Enter phone number',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('type') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="type" render={renderers.selectBox} 
                                                            meta={{
                                                                sublabel: 'Type',
                                                                padding: '0px', 
                                                                placeholder: 'Enter phone type',
                                                                items: data.getPhoneTypes(),
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('current') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('startDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="startDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Start Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter start date',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('endDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="endDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'End Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter end date',
                                                                expandable: false,
                                                                onChange: (val) => {onChange(val, 'endDate', index)}
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td style={{paddingTop: '12px', paddingLeft: '5px'}}>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete phone">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        emailsArray: ({controls, touched, hasError, errors, meta: {type, label, addLabel, onAdd, onRemove, onChange, expandable=true, hidden=null}}) => {
            var selectData = [];
            if (type === 'PERSON') {
                selectData = data.getPersonEmailTypes();
            }
            else if (type === 'ORGANIZATION') {
                selectData = data.getOrgEmailTypes();
            }
            return (
                <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                    {expandable ?
                        <details open>
                            <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                            {controls.map((control, index) => (
                                <div key={`${index}_${controls.length}`}>
                                    <FieldGroup control={control} render={() => (
                                        <table style={{
                                                width: '100%', 
                                                marginBottom: '20px', 
                                                border: '1px solid #D2D6D3', 
                                                padding: '10px', 
                                                borderRadius: '5px',
                                                background: '#eeeeee'
                                            }}>
                                            <tbody>
                                                {(!hidden || hidden.indexOf('value') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="value" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'Email',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter email address',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('type') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="type" render={renderers.selectBox} 
                                                                meta={{
                                                                    sublabel: 'Type',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter email type',
                                                                    items: selectData,
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('current') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="current" 
                                                                render={renderers.checkBox} 
                                                                meta={{
                                                                    sublabel: 'Current',
                                                                    padding: '0px',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('startDate') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="startDate" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'Start Date',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter start date',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('endDate') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="endDate" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'End Date',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter end date',
                                                                    expandable: false,
                                                                    onChange: (val) => {onChange(val, 'endDate', index)}
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td>
                                                        <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete email">
                                                            <span className="fa fa-trash"/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        )}>
                                    </FieldGroup>
                                </div>
                            ))}
                            <div>
                                <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                    <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                                </button>  
                            </div>
                        </details>               
                    :
                        <div>
                            <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                            {controls.map((control, index) => (
                                <div key={`${index}_${controls.length}`}>
                                    <FieldGroup control={control} render={() => (
                                        <table style={{
                                                width: '100%', 
                                                marginBottom: '20px', 
                                                border: '1px solid #D2D6D3', 
                                                padding: '10px', 
                                                borderRadius: '5px',
                                                background: '#eeeeee'
                                            }}>
                                            <tbody>
                                                {(!hidden || hidden.indexOf('value') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="value" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'Email',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter email address',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('type') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="type" render={renderers.selectBox} 
                                                                meta={{
                                                                    sublabel: 'Type',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter email type',
                                                                    items: selectData,
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('current') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="current" 
                                                                render={renderers.checkBox} 
                                                                meta={{
                                                                    sublabel: 'Current',
                                                                    padding: '0px',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('startDate') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="startDate" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'Start Date',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter start date',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                {(!hidden || hidden.indexOf('endDate') == -1) &&
                                                    <tr>
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="endDate" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'End Date',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter end date',
                                                                    expandable: false,
                                                                    onChange: (val) => {onChange(val, 'endDate', index)}
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td style={{paddingTop: '12px', paddingLeft: '5px'}}>
                                                        <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete email">
                                                            <span className="fa fa-trash"/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        )}>
                                    </FieldGroup>
                                </div>
                            ))}
                            <div>
                                <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                    <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                                </button>  
                            </div>
                        </div>
                    }
                    <div>
                        <span style={{color: 'indianred', fontSize: '14px'}}>
                            {hasError('required') && `${label ? label : ''} is required`}
                            {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                        </span>
                    </div>
                </div>
            )
        },

        languageFieldsArray: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, form, expandable=true}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                    <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                        }}>
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                    <FieldControl name='description' 
                                                        render={renderers.textArea} 
                                                        meta={{
                                                            sublabel: 'Description',
                                                            placeholder: 'Enter description',
                                                            height: '200px',
                                                            padding: '0px',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                    <FieldControl name="langCode" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Language Code',
                                                            padding: '0px', 
                                                            placeholder: 'Enter language code',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}>     
                                                    <FieldArray name="urls" 
                                                        render={renderers.textBoxArray} 
                                                        meta={{ 
                                                            sublabel: 'Urls',
                                                            padding: '0px',
                                                            addLabel: 'Add url',
                                                            onAdd: () => {
                                                                const control = form.get('languageFields');
                                                                if (control) {
                                                                    control.controls[index].controls.urls.push(FormBuilder.control());
                                                                }
                                                            },
                                                            onRemove: (idx) => {
                                                                const control = form.get('languageFields');
                                                                if (control) {
                                                                    control.controls[index].controls.urls.removeAt(idx);
                                                                }
                                                            },
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingTop: '20px'}}>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete language field">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                            }}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                    <FieldControl name='description' 
                                                        render={renderers.textArea} 
                                                        meta={{
                                                            sublabel: 'Description',
                                                            placeholder: 'Enter description',
                                                            height: '200px',
                                                            padding: '0px',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                    <FieldControl name="langCode" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Language Code',
                                                            padding: '0px', 
                                                            placeholder: 'Enter language code',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}>     
                                                    <FieldArray name="urls" 
                                                        render={renderers.textBoxArray} 
                                                        meta={{ 
                                                            sublabel: 'Urls',
                                                            padding: '0px',
                                                            addLabel: 'Add url',
                                                            onAdd: () => {
                                                                const control = form.get('languageFields');
                                                                if (control) {
                                                                    control.controls[index].controls.urls.push(FormBuilder.control());
                                                                }
                                                            },
                                                            onRemove: (idx) => {
                                                                const control = form.get('languageFields');
                                                                if (control) {
                                                                    control.controls[index].controls.urls.removeAt(idx);
                                                                }
                                                            },
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete language field">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        citizenshipsArray: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, onSelectChange=null, expandable=true}}) => {
            const countryLabels = data.getCountries();
            const countryCodes = data.getCountryCodes();
            return (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                    <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                        }}>
                                        <tbody>
                                        <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                    <FieldControl 
                                                        name="countryLabel" 
                                                        render={renderers.comboBox} 
                                                        meta={{
                                                            sublabel: 'Country',
                                                            padding: '0px', 
                                                            placeholder: 'Enter Country Name',
                                                            items: countryLabels,
                                                            onSelectChange: (val) => {
                                                                onSelectChange(countryCodes[countryLabels.indexOf(val)], val, index)
                                                            },
                                                            onTextChange: (val) => {
                                                                if(countryLabels.indexOf(val) !== -1){
                                                                    onSelectChange(countryCodes[countryLabels.indexOf(val)], val, index)
                                                                }
                                                            },
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                    <FieldControl 
                                                        name={"countryCode"} 
                                                        render={renderers.comboBox} 
                                                        meta={{
                                                            sublabel: 'Country Code',
                                                            padding: '0px', 
                                                            placeholder: 'Enter Country Code',
                                                            items: countryCodes,
                                                            onSelectChange: (val) => {
                                                                onSelectChange(val, countryLabels[countryCodes.indexOf(val)], index)
                                                            },
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingTop: '20px'}}>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete Citizenship">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                            }}
                                        >
                                        <tbody>    
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                    <FieldControl 
                                                        name="countryLabel" 
                                                        render={renderers.comboBox} 
                                                        meta={{
                                                            sublabel: 'Country',
                                                            padding: '0px', 
                                                            placeholder: 'Enter Country Name',
                                                            items: countryLabels,
                                                            onSelectChange: (val) => {
                                                                onSelectChange(countryCodes[countryLabels.indexOf(val)], val, index)
                                                            },
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                    <FieldControl 
                                                        name={"countryCode"} 
                                                        render={renderers.comboBox} 
                                                        meta={{
                                                            sublabel: 'Country Code',
                                                            padding: '0px', 
                                                            placeholder: 'Enter Country Code',
                                                            items: countryCodes,
                                                            onSelectChange: (val) => {
                                                                onSelectChange(val, countryLabels[countryCodes.indexOf(val)], index)
                                                            },
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete Citizenship">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        )},

        linkArrayBasic: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, form, expandable=true, linkField, hidden=null, kbNames=null}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                    <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px', 
                                            background: '#eeeeee'}}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>         
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                        style={{float: 'left'}}
                                                    />
                                                </td>
                                            </tr>
                                            {(!hidden) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>
                                                        <LinkLookupControl form={form} query={control.value.label} formField={linkField} fieldIndex={index} kbNames={kbNames}/>
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('finchId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                        <FieldControl name='finchId' 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Finch Id',
                                                                placeholder: 'Enter Finch id',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete link">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                            }}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>                    
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            {(!hidden) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>
                                                        <LinkLookupControl form={form} query={control.value.label} formField={linkField} fieldIndex={index} kbNames={kbNames}/>
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('finchId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                        <FieldControl name='finchId' 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Finch Id',
                                                                placeholder: 'Enter Finch id',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete link">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>       
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),
        linkArray: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, form, expandable=true, linkField, hidden=null}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                    <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px', 
                                            background: '#eeeeee'}}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>         
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                        style={{float: 'left'}}
                                                    />
                                                </td>
                                            </tr>
                                            {(!hidden) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>
                                                        <LinkLookupControl form={form} query={control.value.label} formField={linkField} fieldIndex={index}/>
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('finchId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                        <FieldControl name='finchId' 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Finch Id',
                                                                placeholder: 'Enter Finch id',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('permId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="permId" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Perm Id',
                                                                padding: '0px', 
                                                                placeholder: 'Enter perm id',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete link">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                            }}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>                    
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            {(!hidden) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>
                                                        <LinkLookupControl form={form} query={control.value.label} formField={linkField} fieldIndex={index}/>
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('finchId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                        <FieldControl name='finchId' 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Finch Id',
                                                                placeholder: 'Enter Finch id',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('permId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="permId" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Perm Id',
                                                                padding: '0px', 
                                                                placeholder: 'Enter perm id',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete link">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>       
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        linkArray2: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, onChange, form, expandable=true, linkField, typeData=null, hidden=null}}) => (
            <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                {expandable ?
                    <details open>
                        <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px', 
                                            background: '#eeeeee'}}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>         
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                        style={{float: 'left'}}
                                                    />
                                                </td>
                                            </tr>
                                            {!hidden &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>
                                                        <LinkLookupControl form={form} query={control.value.label} formField={linkField} fieldIndex={index}/>
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('finchId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                        <FieldControl name='finchId' 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Finch Id',
                                                                placeholder: 'Enter Finch id',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('permId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="permId" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Perm Id',
                                                                padding: '0px', 
                                                                placeholder: 'Enter perm id',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('type') == -1) &&
                                                <tr>
                                                    {typeData ?
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="type" 
                                                                render={renderers.comboBox} 
                                                                meta={{
                                                                    sublabel: 'Type',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter type',
                                                                    items: typeData,
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    :
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="type" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'Type',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter type',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('title') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="title" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Title',
                                                                padding: '0px', 
                                                                placeholder: 'Enter title',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('current') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px', 
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('startDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="startDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Start Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter start date',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('endDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="endDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'End Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter end date',
                                                                expandable: false,
                                                                onChange: (val) => {onChange(val, 'endDate', index)}
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete link">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </details>                
                :
                    <div>
                        <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                        {controls.map((control, index) => (
                            <div key={`${index}_${controls.length}`}>
                                <FieldGroup control={control} render={() => (
                                    <table style={{
                                            width: '100%', 
                                            marginBottom: '20px', 
                                            border: '1px solid #D2D6D3', 
                                            padding: '10px', 
                                            borderRadius: '5px',
                                            background: '#eeeeee'
                                            }}
                                        >
                                        <tbody>
                                            <tr>
                                                <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>                    
                                                    <FieldControl name="label" 
                                                        render={renderers.textBox} 
                                                        meta={{
                                                            sublabel: 'Label',
                                                            padding: '0px', 
                                                            placeholder: 'Enter label',
                                                            expandable: false
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            {!hidden &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%', verticalAlign: 'top'}}>
                                                        <LinkLookupControl form={form} query={control.value.label} formField={linkField} fieldIndex={index}/>
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('finchId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}> 
                                                        <FieldControl name='finchId' 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Finch Id',
                                                                placeholder: 'Enter Finch id',
                                                                padding: '0px',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('permId') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="permId" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Perm Id',
                                                                padding: '0px', 
                                                                placeholder: 'Enter perm id',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('type') == -1) &&
                                                <tr>
                                                    {typeData ?
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="type" 
                                                                render={renderers.comboBox} 
                                                                meta={{
                                                                    sublabel: 'Type',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter type',
                                                                    items: typeData,
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    :
                                                        <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                            <FieldControl name="type" 
                                                                render={renderers.textBox} 
                                                                meta={{
                                                                    sublabel: 'Type',
                                                                    padding: '0px', 
                                                                    placeholder: 'Enter type',
                                                                    expandable: false
                                                                }}
                                                            />
                                                        </td>
                                                    }
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('title') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="title" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Title',
                                                                padding: '0px', 
                                                                placeholder: 'Enter title',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('current') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px', 
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('startDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="startDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Start Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter start date',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            {(!hidden || hidden.indexOf('endDate') == -1) &&
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="endDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'End Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter end date',
                                                                expandable: false,
                                                                onChange: (val) => {onChange(val, 'endDate', index)}
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>
                                                    <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete link">
                                                        <span className="fa fa-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    )}>
                                </FieldGroup>
                            </div>
                        ))}
                        <div>
                            <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                            </button>  
                        </div>
                    </div>       
                }
                <div>
                    <span style={{color: 'indianred', fontSize: '14px'}}>
                        {hasError('required') && `${label ? label : ''} is required`}
                        {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                    </span>
                </div>
            </div>
        ),

        identifiersArray: ({controls, touched, hasError, errors, meta: {label, addLabel, onAdd, onRemove, onChange, form, expandable=true}}) => {
            return (
                <div className="form-field-wrapper" style={{background: 'whitesmoke', padding: '10px', borderRadius: '5px'}}>
                    {expandable ?
                        <details open>
                            <summary  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</summary>
                            {controls.map((control, index) => (
                                <div key={`${index}_${controls.length}`}>
                                    <FieldGroup control={control} render={() => (
                                        <table style={{
                                                width: '100%', 
                                                marginBottom: '20px', 
                                                border: '1px solid #D2D6D3', 
                                                padding: '10px', 
                                                borderRadius: '5px',
                                                background: '#eeeeee'
                                            }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>
                                                        <FieldControl name="type" 
                                                            render={renderers.comboBox} 
                                                            meta={{
                                                                sublabel: 'Type',
                                                                padding: '0px', 
                                                                placeholder: 'Enter type',
                                                                items: data.getIdentifierTypes(),
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="value" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Id',
                                                                padding: '0px', 
                                                                placeholder: 'Enter id value',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="primary" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Primary',
                                                                padding: '0px', 
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px', 
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="startDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Start Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter start date',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="endDate"
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'End Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter end date',
                                                                expandable: false,
                                                                onChange: (val) => {onChange(val, 'endDate', index)}
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingTop: '20px'}}>
                                                        <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete identifier">
                                                            <span className="fa fa-trash"/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        )}>
                                    </FieldGroup>
                                </div>
                            ))}
                            <div>
                                <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                    <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                                </button>  
                            </div>
                        </details>                
                    :
                        <div>
                            <div  className="form-label" style={{paddingBottom: label ? '5px' : '0px'}}>{label ? label : null }</div>
                            {controls.map((control, index) => (
                                <div key={`${index}_${controls.length}`}>
                                    <FieldGroup control={control} render={() => (
                                        <table style={{
                                                width: '100%', 
                                                marginBottom: '20px', 
                                                border: '1px solid #D2D6D3', 
                                                padding: '10px', 
                                                borderRadius: '5px',
                                                background: '#eeeeee'
                                                }}
                                            >
                                            <tbody>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>
                                                        <FieldControl name="type" 
                                                            render={renderers.comboBox} 
                                                            meta={{
                                                                sublabel: 'Type',
                                                                padding: '0px', 
                                                                placeholder: 'Enter type',
                                                                items: data.getIdentifierTypes(),
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="value" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Id',
                                                                padding: '0px', 
                                                                placeholder: 'Enter id value',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="primary" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Primary',
                                                                padding: '0px', 
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="current" 
                                                            render={renderers.checkBox} 
                                                            meta={{
                                                                sublabel: 'Current',
                                                                padding: '0px', 
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="startDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'Start Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter start date',
                                                                expandable: false
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingBottom: '10px', width: '100%'}}>                    
                                                        <FieldControl name="endDate" 
                                                            render={renderers.textBox} 
                                                            meta={{
                                                                sublabel: 'End Date',
                                                                padding: '0px', 
                                                                placeholder: 'Enter end date',
                                                                expandable: false,
                                                                onChange: (val) => {onChange(val, 'endDate', index)}
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{paddingTop: '20px'}}>
                                                        <button className="form-danger-button" onClick={onRemove ? ()=>{onRemove(index)} : null} title="Delete identifier">
                                                            <span className="fa fa-trash"/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        )}>
                                    </FieldGroup>
                                </div>
                            ))}
                            <div>
                                <button className="form-primary-button" onClick={onAdd ? onAdd : null} title={addLabel ? addLabel : 'Create new item'}>
                                    <span className="fa fa-plus-circle"/> {addLabel ? addLabel : ''}
                                </button>  
                            </div>
                        </div>
                    }
                    <div>
                        <span style={{color: 'indianred', fontSize: '14px'}}>
                            {hasError('required') && `${label ? label : ''} is required`}
                            {hasError('minLength') && `${label ? label : ''} minimum length ${errors['minLength']['requiredLength']}`}
                        </span>
                    </div>
                </div>
            )
        }
    }

    export default renderers;